module.exports = __webpack_public_path__ + "static/media/dbj_geren_icon.6289893b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dbj_geren_icon.png
// module id = 424
// module chunks = 0